import PropTypes from 'prop-types';
import React from 'react';
import RegulatoryNotice from '@components/vehiclefleet/RegulatoryNotice';
import { Box, Container } from '@mui/material';
import LeasingConditionsNotice from '@components/vehiclefleet/LeasingConditionsNotice';
import EvSubsidyNotice from '@components/vehiclefleet/EvSubsidyNotice';
import WarrantyNotice from '@components/vehiclefleet/WarrantyNotice';
import PageContainer from '../organisms/PageContainer';

export default function DefaultTemplate(props) {
  const {
    children,
    leasingProduct,
    warrantyNotice,
  } = props;

  return (
    <PageContainer>
      {children}
      <Container>
        <Box my={5}>
          {warrantyNotice && (<WarrantyNotice mt={1} />)}
          <RegulatoryNotice mt={1} />
          {leasingProduct && (<LeasingConditionsNotice mt={1} text={leasingProduct} />)}
          <EvSubsidyNotice mt={1} />
        </Box>
      </Container>
    </PageContainer>
  );
}

DefaultTemplate.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
